import { createSlice } from '@reduxjs/toolkit';

export const employeeSlice = createSlice({
    name: 'employee',
    initialState: {
        error: "",
        uniqueAddresses: [],
        pendingDeliveries: [],
        verifiedCustomerHamperList: []
    },
    reducers: {
        updateAddresses: (state, action) => {
            state.error = "";
            state.uniqueAddresses = action.payload.uniqueAddresses;
            state.pendingDeliveries = action.payload.pendingDeliveries;
        },
        clearAddresses: (state) => {
            state.error = "";
            state.uniqueAddresses = "";
            state.pendingDeliveries = "";
        },
        addressSearch: () => {},
        updateCustomerHamperList: (state, action) => {
            state.error = "";
            state.verifiedCustomerHamperList = action.payload.verifiedCustomerHamperList;
        },
        clearCustomerHamperList: (state) => {
            state.error = "";
            state.verifiedCustomerHamperList = "";
        },
        customerHamperList: () => {},
    },
})

export const {
    updateAddresses,
    clearAddresses,
    addressSearch,
    updateCustomerHamperList,
    clearCustomerHamperList,
    customerHamperList
} = employeeSlice.actions;

export default employeeSlice.reducer;